import { Header } from '@components/Header';
import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const AdminDiffPage = () => {
  return (
    <>
      <Helmet>
        <title>Diff - AutoScript Admin</title>
      </Helmet>
      <Header title="Diff" />

      <PageProvider>
        <Content />
      </PageProvider>
    </>
  );
};
